package de.oevbs.kunde.kundenportal2.services.contract.lineofbusiness

import de.oevbs.businesspartner.bpcrmservice2.contract.model.ContractDetails
import de.oevbs.businesspartner.bpcrmservice2.contract.model.Participant
import de.oevbs.businesspartner.bpcrmservice2.partner.model.toView
import de.oevbs.kunde.kundenportal2.components.inlineLink
import de.oevbs.kunde.kundenportal2.components.paragraph
import de.oevbs.kunde.kundenportal2.services.contract.detailsPersonRoleTable
import de.oevbs.kunde.kundenportal2.services.contract.detailsPersonRoleTableEntry
import de.oevbs.kunde.kundenportal2.services.contract.detailsSection
import de.oevbs.sfa.data.time.toLocalizedString
import dev.fritz2.core.RenderContext


/**
 * Vertragsdetails der Krankenzusatzversicherung
 * Details werden von den Kooperationspartnern gepflegt. Daher der Verweis für den Kunden.
 */
fun RenderContext.contractDetailsHealth(contractDetail: ContractDetails) {
    contractDetailsHealthParticipantsByName(contractDetail.participants)
    detailsSection("Ihr Versicherungsschutz") {
        paragraph {
            p {
                +"""Weitere Informationen zu Ihrem Vertrag und zum Thema Krankenversicherung erhalten Sie bei 
                |unserem Kooperationspartner.""".trimMargin()
            }
            p { +"Ihren Ansprechpartner finden Sie auf Ihrem Versicherungsschein." }
            inlineLink(
                text = "https://www.oeffentliche.de/content/produkte/krankenversicherung/",
                link = "https://www.oeffentliche.de/content/produkte/krankenversicherung/",
                target = "_blank"
            )
        }
    }
}

/**
 * Anzeige der Vertragsbeteiligten, sobald unterschiedliche NAMEN beteiligt sind.
 * Filtert für die Anzeige die doppelten Einträge heraus, behält aber deren Rolleninformationen.
 *
 * @param participants: Liste der beteiligten Personen
 */
private fun RenderContext.contractDetailsHealthParticipantsByName(participants: List<Participant>) {
    val participantsByName = participants.groupBy(Participant::name)
    detailsSection("Vertragsbeteiligte") {
        detailsPersonRoleTable {
            participantsByName.mapNotNull { nameGroup ->
                val participant = nameGroup.value.first()
                val roles = nameGroup.value.map { it.role.value }.distinct().joinToString()
                participant to roles
            }.forEach { (participant, roles) ->
                detailsPersonRoleTableEntry(
                    participant.name,
                    participant.address.toView(),
                    participant.birthdate?.toLocalizedString(),
                    roles
                )
            }
        }
    }
}